import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ApiService } from '@shared/services';
import { ReferralReportsFilters } from '@modules/reports/models/referral-reports-filters';
import { Observable } from 'rxjs';
import { DashboardReportModel } from '@shared/models/dashboard-reports';

@Injectable({
  providedIn: 'root',
})
export class ReportDashboardService extends ApiService<any> {
  constructor(http: HttpClient) {
    super(http);
    this.url = 'aggregated/dashboard/';
  }

  getDashboardReportService(params: ReferralReportsFilters): Observable<DashboardReportModel> {
    return this.get({ url: 'total-applicants', params });
  }

  getDashboardReportServiceOffer(params: ReferralReportsFilters): Observable<DashboardReportModel> {
    return this.get({ url: 'offer-applicants', params });
  }
}
